import RequestStatus from 'types/general/requests/RequestStatus';
import EStatusAPIKeys from 'types/backend_models/lookup_status/EStatusAPIKeys';
import IStatusModel from 'types/backend_models/lookup_status/IStatusModel';
import { IDefaultRequestProps } from 'types/general/GeneralStateModelInterfaces';
import { PayloadAction, CaseReducer, createSlice } from '@reduxjs/toolkit';

/* DEFAULT STATE & TYPES */
export interface IStatusStateModel extends IDefaultRequestProps {
	data: IStatusModel[] | null
}

type TStatusDataState = {
	[EStatusAPIKeys.deliveryStatuses]: IStatusStateModel,
	[EStatusAPIKeys.invoiceStatuses]: IStatusStateModel,
	[EStatusAPIKeys.orderStatuses]: IStatusStateModel,
	[EStatusAPIKeys.productStatuses]: IStatusStateModel
}


const defaultState: TStatusDataState = {
	[EStatusAPIKeys.deliveryStatuses]: { requestStatus: RequestStatus.idle, data: null, error: null },
	[EStatusAPIKeys.invoiceStatuses]: { requestStatus: RequestStatus.idle, data: null, error: null },
	[EStatusAPIKeys.orderStatuses]: { requestStatus: RequestStatus.idle, data: null, error: null },
	[EStatusAPIKeys.productStatuses]: { requestStatus: RequestStatus.idle, data: null, error: null }
}

/* REDUCERS */
const setFetchStatusPendingReducer: CaseReducer<TStatusDataState, PayloadAction<{ statusKey: EStatusAPIKeys }>> = (state: TStatusDataState, action) => {
	let statusObject = state[action.payload.statusKey];
	statusObject.data = null;
	statusObject.requestStatus = RequestStatus.pending;
	statusObject.error = null;
}
const setFetchStatusSuccesReducer: CaseReducer<TStatusDataState, PayloadAction<{ data: IStatusModel[], statusKey: EStatusAPIKeys }>> = (state: TStatusDataState, action) => {
	let statusObject = state[action.payload.statusKey];
	statusObject.data = action.payload.data;
	statusObject.requestStatus = RequestStatus.succes;
}
const setFetchStatusErrorReducer: CaseReducer<TStatusDataState, PayloadAction<{ statusKey: EStatusAPIKeys, error: string }>> = (state: TStatusDataState, action) => {
	let statusObject = state[action.payload.statusKey];
	statusObject.data = null;
	statusObject.error = action.payload.error;
	statusObject.requestStatus = RequestStatus.error;
}

/* SLICE */
const statusDataSlice = createSlice({
	name: 'statusData',
	initialState: defaultState,
	reducers: {
		setFetchStatusPending: setFetchStatusPendingReducer,
		setFetchStatusSucces: setFetchStatusSuccesReducer,
		setFetchStatusError: setFetchStatusErrorReducer
	}
});

export const {
	setFetchStatusPending,
	setFetchStatusSucces,
	setFetchStatusError
} = statusDataSlice.actions;

export default statusDataSlice.reducer;

/* OLD REDUCER */

// function statusDataReducer(state = defaultState, action: TStatusDataActionTypes): TStatusDataState {
// 	switch (action.type) {
// 		case FETCH_STATUS_PENDING: {
// 			return {
// 				...state,
// 				[action.statusAPIKey]: {
// 					requestStatus: RequestStatus.pending,
// 					data: null
// 				}
// 			}
// 		}
// 		case FETCH_STATUS_SUCCESS: {
// 			return {
// 				...state,
// 				[action.statusAPIKey]: {
// 					requestStatus: RequestStatus.succes,
// 					data: action.data.sort(Shared.Formatters.dynamicSort("sortOrder"))
// 				}
// 			}
// 		}
// 		case FETCH_STATUS_ERROR: {
// 			return {
// 				...state,
// 				[action.statusAPIKey]: {
// 					requestStatus: RequestStatus.error,
// 					data: null
// 				}
// 			}
// 		}
// 		default: {
// 			return state;
// 		}
// 	}
// }

// export default statusDataReducer;